/* MyPhoneCase: apply model option filters before Shopify paginates results. */
(() => {
  const key = 'filter.v.option.model';
  function models(term) {
    const text = term.toLowerCase().normalize('NFKC').replace(/ı/g, 'i')
      .replace(/([0-9])(?=[a-z])/g, '$1 ').replace(/pro\s*max/g, 'pro max')
      .replace(/\s+/g, ' ').trim();
    const iphone = text.match(/^(?:apple\s+)?(?:iphone\s*)?(1[1-9])(?:\s+(pro max|pro|plus|mini|air))?(?:\s+(?:kılıfı|kilifi|kılıf|kilif|kılıfları|kiliflari))?$/);
    if (iphone) {
      const base = `iPhone ${iphone[1]}`;
      if (iphone[2]) return [base + ' ' + ({'pro max':'Pro Max',pro:'Pro',plus:'Plus',mini:'Mini',air:'Air'}[iphone[2]])];
      return [base, ...['Pro', 'Pro Max', 'Plus', 'Mini', 'Air'].map(s => base + ' ' + s)];
    }
    const samsung = text.match(/^(?:samsung\s+)?(?:galaxy\s+)?s\s*(2[0-9])(?:\s+(ultra|plus|fe))?$/);
    if (samsung) return ['Samsung S' + samsung[1] + (samsung[2] ? ' ' + samsung[2].toUpperCase().replace('ULTRA','Ultra').replace('PLUS','Plus') : '')];
    return [];
  }
  function apply(url, term) {
    const values = models(term);
    url.searchParams.set('q', term);
    if (!values.length) return false;
    url.searchParams.set('type', 'product');
    url.searchParams.delete(key);
    values.forEach(v => url.searchParams.append(key, v));
    return true;
  }
  window.MPCModelSearch = { models, apply };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !new URL(form.action, location.origin).pathname.endsWith('/search')) return;
    const url = new URL(form.action, location.origin);
    if (!apply(url, input.value.trim())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(url.toString());
  }, true);
  // Also fix direct menu links and bookmarked model searches.
  const current = new URL(location.href);
  if (current.pathname.endsWith('/search') && !current.searchParams.has('section_id')) {
    const values = models(current.searchParams.get('q') || '');
    if (values.length && !current.searchParams.has(key)) {
      apply(current, current.searchParams.get('q'));
      current.searchParams.delete('page');
      location.replace(current.toString());
    }
  }
})();
